<template>
  <vue-select style="width: 100%" :value="value" @search="getOptions" id="product-name-id"
    :options="$store.state.productsearch.product_search" label="label" class="select-x"
    placeholder="cari berdasarkan kata kunci" @input="changed" :loading="isLoading" />
</template>

<script>
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { convertObjToString } from "../lib/helpers";

export default {
  components: {
    VueSelect,
  },
  name: "ProductNameSelector",
  props: ["value", "query"],
  data () {
    return {
      isLoading: false
    }
  },
  async created () {
    await this.$store.dispatch('get_product_search', '')
  },
  methods: {
    async init (q) {
      var qAdd = `q=${q}`;
      if (this.query) {
        qAdd += "&" + convertObjToString(this.query);
      }
      await this.$store.dispatch('get_product_search', qAdd)
    },
    async getOptions (search, loading) {
      this.isLoading = true;
      loading(true);
      try {
        await this.init(search);
      } finally {
        this.isLoading = false;
        loading(false);
      }
    },
    changed (evt) {
      this.$emit("input", evt);
    },
  },
};
</script>

<style scoped>

</style>
